export default __webpack_public_path__ + "static/media/ios.d6a94c32.svg";